<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IsiIE0/tc-custom/9781449400217.jpg?1705025894452" alt="This image is the cover for the book At Our Table"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">At Our Table
      </h1>
      <p class="bookDescription body article font2">
        <b>An illustrated collection of recipes for meals to be shared with family and friends, with tips on how to make the most of getting together with loved ones.</b><br/><br/>With their fifth collaboration, <i>At Our Table</i>, Roxie Kelley and Shelly Reeves Smith set out to create a cookbook seasoned with their insights gleaned over thirty years as friends and business partners. The result is both a cookbook and a celebration of those special times when we gather our friends and family at our table.<br/><br/>Offering 125 simple, delicious recipes, <i>At Our Table</i> emphasizes how the experience of gathering for meals can energize us and help us recognize the richness and fullness of our lives. Ideal for home cooks who savor the simple life, <i>At Our Table</i> magically combines Kelley's conversational writing style and Smith's beautiful illustrations to inspire us all to return to our tables. <br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Roxie Kelley, Shelly Reeves Smith
      </h2>
      
      <p class="authorDescription body article">Roxie Kelley has authored more than 10 best-selling cookbooks and founded three restaurants, a home decor store, and a manufacturing company, all based in Lake of the Ozarks. She finds her inspiration through her faith, her family, and close friends. She is currently residing in St.Louis, MO. You may find some of her bakery creations at local Farmers' Markets in the St.Louis area. Illustrator Kathleen Taylor has worked as a corporate designer, as well as a painter, mixed media artist, writer, editor, and photo stylist. She owns her own studio aptly named the Kathleen Taylor Studio. Her art has been licensed for many gift products. It has also been featured in numerous books, magazines and film. Kathleen's work is available at www.kathleentaylorstudio.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c69ec504